import LocationController from "@/server/controllers/LocationController";
import { Seller } from "@prisma/client";

export default class SellerHelper {
  static getImagePath(seller: Seller) {
    return (
      "https://makazimapya.s3.amazonaws.com/public/dp/" + seller.thumbnail_path
    );
  }

  static async getQueryPramsInfo(queryParams: any, locale: "" | "en" = "") {
    let location = null;

    if (queryParams.location) {
      location = await LocationController.getOne(queryParams.location);
    }

    return this.setQueryPramsInfo(
      queryParams,
      location?.full_name || "",
      locale
    );
  }

  static setQueryPramsInfo(
    queryParams: any,
    locationName: string = null,
    locale: "" | "en" = ""
  ) {
    let seoTitle: string;
    let seoDescription: string;
    let pageTitle: string;
    let pageDescription: string;

    if (locationName == null || locationName == "") {
      if (locale == "en") {
        seoTitle = `List of Real Estate Agents in Tanzania`;
        seoDescription = `Find Real Estate Agents in Tanzania`;
        pageTitle = `Real Estate Agents`;
        pageDescription = `List of Real Estate Agents in Tanzania`;
      } else {
        seoTitle = `Pata Madalali wa nyumba na viwanja Tanzania`;
        seoDescription = `Pata Madalali wa nyumba na viwanja Tanzania`;
        pageTitle = `Madalali wa nyumba na viwanja`;
        pageDescription = `Orodha Madalali wa nyumba na viwanja`;
      }
    } else {
      let locationConnectorEn =
        locationName.split(", ").length > 1 ? " at " : " in ";
      if (locale == "en") {
        seoTitle = `List of Real Estate Agents ${locationConnectorEn} ${locationName} Tanzania`;
        seoDescription = `Find Real Estate Agents ${locationConnectorEn} ${locationName} Tanzania`;
        pageTitle = `Real Estate Agents ${locationConnectorEn} ${locationName}`;
        pageDescription = `Real Estate Agents ${locationConnectorEn} ${locationName} Tanzania`;
      } else {
        locationName = "wa " + locationName;
        seoTitle = `Pata Madalali wa nyumba na viwanja ${locationName} Tanzania`;
        seoDescription = `Pata Madalali wa nyumba na viwanja ${locationName} Tanzania`;
        pageTitle = `Madalali wa nyumba na viwanja ${locationName}`;
        pageDescription = `Madalali wa nyumba na viwanja ${locationName} Tanzania`;
      }
    }

    return {
      seoTitle,
      seoDescription,
      pageTitle,
      pageDescription,
    };
  }

  static toSentenceCase(str: string) {
    str = str.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}
